const LOGLEVEL = require('../../../../../lib/log/logLevel.js');
let config;

try {
	config = require('core/config');
} catch (e) {
	config = {
		log: {}
	};
}

const logConfig = config.log;
const environmentLevel = logConfig.uiLevel || LOGLEVEL.ERROR;

// Numbered priorities based on the LOGLEVEL.priority index
const ORDERED_LEVELS = LOGLEVEL.priority.reduce((acc, level, index) => {
	acc[level] = index;
	return acc;
}, {});

/* eslint-disable no-console */
const logInfo = messages => console.log(...messages);
const logWarn = messages => console.warn(...messages);
const logError = messages => console.error(...messages);
/* eslint-enable no-console */

let logger = {
	log(level, ...messages) {
		let levelPriority = ORDERED_LEVELS[level];

		// If unknown / no log level, assume low priority message.
		if (typeof levelPriority !== 'number') {
			levelPriority = ORDERED_LEVELS[LOGLEVEL.DEBUG];
			messages.unshift(level);
		}

		// If the message is allowed to be logged for this environment
		if (levelPriority >= ORDERED_LEVELS[environmentLevel]) {
			let logFunc = logInfo;

			if (levelPriority === ORDERED_LEVELS[LOGLEVEL.WARN]) {
				logFunc = logWarn;
			} else if (levelPriority >= ORDERED_LEVELS[LOGLEVEL.ERROR]) {
				logFunc = logError;
			}

			logFunc(messages);
		}
	}
};

LOGLEVEL.priority.forEach(priority => {
	// add methods for all priority levels
	// (logger.info(), logger.warn(), logger.error(), etc.)
	logger[priority] = (...messages) => logger.log(priority, ...messages);
});

module.exports = logger;
